import axios from '@/utils/request';

function MODULE_SET(params) {
    return axios.get("/kshadmin/PanelRole/moduleSet", {
        params: params
    })
}

function MODULE_SET_POST(params) {
    return axios.post("/kshadmin/PanelRole/moduleSetPost", {
        ...params
    })
}

export default {
    MODULE_SET,
    MODULE_SET_POST
};